import fetchModels from "@/mixin/store/api/fetchModels";
import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleProductRatingAllPeriod(context) {
            if (context.state.saleProductRatingAllPeriod.isNeedFetch) {
                return fetchModels(context, 'sale_product_yearly_ratings/all_period', null, 'updateSaleProductRatingAllPeriod')
            }
        },
        fetchSaleProductYearlyRating(context, searchItem) {
            let url = "sale_product_yearly_ratings?page="  + searchItem.page

            if (!context.state.saleProductYearlyRating.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byAmount) {
                url = url + '&order[amount]=desc'
            } else {
                url = url + '&order[incomeAmount]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleProductYearlyRating', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateSaleProductRatingAllPeriod(state, data) {
            state.saleProductRatingAllPeriod = data
            state.saleProductRatingAllPeriod.isNeedFetch = false
        },
        updateSaleProductYearlyRating(state, data) {
            state.saleProductYearlyRating = data
            state.saleProductYearlyRating.isNeedFetch = false
        },
    },
    state: {
        saleProductRatingAllPeriod: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        saleProductYearlyRating: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleProductRatingAllPeriod(state) {
            return state.saleProductRatingAllPeriod.models
        },
        getSaleProductYearlyRating(state) {
            return state.saleProductYearlyRating.models
        },
        getSaleProductYearlyRatingTotalCount(state) {
            return state.saleProductYearlyRating.totalItems
        },
    },
}
